// Generated by scripts/update-seeq-icons.js from src/svg/seeq/metric.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcMetric = {
  prefix: 'fak',
  iconName: 'metric' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f951',
    'M972.8 0h-921.6c-30.7 0-51.2 20.5-51.2 51.2v921.6c0 30.7 20.5 51.2 51.2 51.2h921.6c30.7 0 51.2-20.5 51.2-51.2v-921.6c0-30.7-20.5-51.2-51.2-51.2zM353.3 240.6l20.5-15.3c10.2-10.2 20.5-10.2 30.7 0l92.1 97.3 169-184.4c10.2-10.2 20.5-10.2 30.7 0l20.5 15.4c10.2 10.2 10.2 20.5 0 30.7l-220.2 240.7-143.3-153.6c-10.2-10.2-10.2-25.6 0-30.8zM921.6 921.6h-819.2v-409.6h819.2v409.6zM660.5 593.9l-15.4-15.3c-10.2-10.2-20.5-10.2-30.7 0l-102.4 97.2-97.3-97.2c-10.2-10.2-20.5-10.2-30.7 0l-15.4 15.3c-10.2 10.2-10.2 20.5 0 30.7l97.3 97.3-97.3 97.3c-10.2 10.2-10.2 20.5 0 30.7l10.3 20.5c10.2 10.2 20.5 10.2 30.7 0l97.3-97.3 97.3 97.3c10.2 10.2 20.5 10.2 30.7 0l15.3-15.4c10.2-10.2 10.2-20.5 0-30.7l-97.2-97.3 97.2-97.2c15.4-10.2 15.4-25.6 10.3-35.9z',
  ],
} satisfies IconDefinition;
